import { React } from "react";

export default function Footer() {
  return (
    <footer className="mx-auto">
      <p className="text-center p-2">
        Made with love in Seattle, WA. Questions?{" "}
        <a href="mailto:email@example.com">Contact Us!</a>
      </p>
    </footer>
  );
}
